function arrayBufferToBase64(buffer) {
  let binary = '';
  const bytes = new Uint8Array(buffer);
  const len = bytes.byteLength;
  for (let i = 0; i < len; i += 1) {
    binary += String.fromCharCode(bytes[i]);
  }
  return window.btoa(binary);
}

async function arrayBufferToBase64Wrapper(file, body, request, assignFunction) {
  try {
    const buffer = await file.arrayBuffer();
    const fileByteArray = arrayBufferToBase64(buffer);
    Object.assign(body, assignFunction(fileByteArray));
    return request(body);
  } catch (err) {
    return Promise.resolve();
  }
}

export {
  arrayBufferToBase64,
  arrayBufferToBase64Wrapper,
};
